import { render, staticRenderFns } from "./ManuInfo.vue?vue&type=template&id=486d754c&scoped=true&"
import script from "./ManuInfo.vue?vue&type=script&lang=js&"
export * from "./ManuInfo.vue?vue&type=script&lang=js&"
import style0 from "./ManuInfo.vue?vue&type=style&index=0&id=486d754c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d754c",
  null
  
)

export default component.exports